import React, { useMemo } from 'react';
import { FaBroadcastTower, FaChartLine, FaSpinner } from 'react-icons/fa';
import GiftSetDeviceCard from './GiftSetDeviceCard';

const GiftSetMembersSection = ({
  group,
  isLoading,
  memberRows,
  onRemoveMember,
  ownerMember,
  theme,
}) => {
  const totalOpens = useMemo(() => (
    [ownerMember, ...memberRows].reduce((sum, member) => sum + Number(member?.scanCount || 0), 0)
  ), [memberRows, ownerMember]);
  const totalDevices = 1 + memberRows.length;

  return (
    <div className="mt-5 space-y-3">
      <div className="rounded-[1.15rem] border p-4" style={{ borderColor: theme.cardBorder, backgroundColor: theme.cardBg }}>
        <div className="flex items-center justify-between gap-3">
          <div>
            <p className="text-[9px] font-black uppercase tracking-[0.24em]" style={{ color: theme.accent }}>
              Member Management
            </p>
            <h4 className="mt-1 text-sm font-black" style={{ color: theme.text }}>
              {group?.name || 'Gift Set'}
            </h4>
          </div>
          {isLoading && <FaSpinner className="animate-spin opacity-50" />}
        </div>

        <div className="mt-4 grid grid-cols-2 gap-2">
          <div className="rounded-[0.9rem] border px-3 py-2" style={{ borderColor: theme.cardBorder }}>
            <div className="flex items-center gap-2 text-[8px] font-black uppercase tracking-widest opacity-50">
              <FaBroadcastTower /> NFCs
            </div>
            <div className="mt-1 text-lg font-black" style={{ color: theme.text }}>
              {totalDevices}
            </div>
          </div>
          <div className="rounded-[0.9rem] border px-3 py-2" style={{ borderColor: theme.cardBorder }}>
            <div className="flex items-center gap-2 text-[8px] font-black uppercase tracking-widest opacity-50">
              <FaChartLine /> Opens
            </div>
            <div className="mt-1 text-lg font-black" style={{ color: theme.text }}>
              {totalOpens}
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between pt-2">
        <span className="text-[9px] font-black uppercase tracking-widest opacity-50">Owner Device</span>
        <span className="text-[9px] font-black uppercase tracking-widest" style={{ color: theme.accent }}>
          Master
        </span>
      </div>

      <GiftSetDeviceCard member={ownerMember} theme={theme} variant="owner" />

      <div className="flex items-center justify-between pt-2">
        <span className="text-[9px] font-black uppercase tracking-widest opacity-50">
          Member NFCs ({memberRows.length})
        </span>
        {group && (
          <span className="max-w-[45%] truncate text-[9px] font-black uppercase tracking-widest opacity-50">
            {group.name}
          </span>
        )}
      </div>

      {memberRows.length === 0 ? (
        <div
          className="rounded-[1.1rem] border border-dashed p-5 text-center"
          style={{ borderColor: theme.cardBorder, backgroundColor: theme.cardBg }}
        >
          <div className="mx-auto flex h-10 w-10 items-center justify-center rounded-[1rem]" style={{ backgroundColor: theme.accentSoft, color: theme.accent }}>
            <FaBroadcastTower />
          </div>
          <p className="mt-3 text-sm font-black" style={{ color: theme.text }}>
            No member NFCs yet
          </p>
          <p className="mt-1 text-xs font-bold leading-relaxed opacity-55">
            Start pairing, then tap another NFC. It will become an entry point for this owner gift.
          </p>
        </div>
      ) : memberRows.map((member) => (
        <GiftSetDeviceCard
          key={member.uuid}
          member={member}
          onRemove={onRemoveMember}
          theme={theme}
        />
      ))}
    </div>
  );
};

export default GiftSetMembersSection;
